import React from "react";
import UploadForm from "./UploadForm";

import "./style.scss";
import FilterCard from "./FilterCard";
import DeteriorationRank from "./DeteriorationRank";
import FilterRoadSurface from "./FilterRoadSurface";
import { AccessPeriodCard } from "./AccessPeriodCard";
import FilterRoadPredict from "./FilterRoadPredict";

const GisMapDetail = ({ closeSurveyedDetail, mapEl }) => {
  return (
    <div className="gis-map-detail">
      <div>
        {/* User/Address/Filter */}
        <FilterCard mapEl={mapEl} closeSurveyedDetail={closeSurveyedDetail} />
        {/* Actual/Predicted Filter */}
        <FilterRoadPredict />
        {/* Surface Condition */}
        <DeteriorationRank closeSurveyedDetail={closeSurveyedDetail} />
        {/* Surface Type */}
        <FilterRoadSurface />
        <UploadForm />
        <div className="upload-container"></div>
        <AccessPeriodCard />
      </div>
    </div>
  );
};

export default GisMapDetail;
